import { render, staticRenderFns } from "./TambahBarang.vue?vue&type=template&id=d268c792&"
import script from "./TambahBarang.vue?vue&type=script&lang=js&"
export * from "./TambahBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports